import {BehaviorSubject} from 'rxjs';
import {IDataSpell} from "../_interfaces/IDataSpell";
import {IDataTalentSkill} from "../_interfaces/IDataTalentSkill";
import {IDataDiscipline} from "../_interfaces/IDataDiscipline";
import {IDataBloodmagicItem} from "../_interfaces/IDataBloodmagicItem";

const TalentSkillSubscriber = new BehaviorSubject<IDataTalentSkill[]>([]);
const SpellsSubscriber = new BehaviorSubject<IDataSpell[]>([]);
const DisciplinesSubscriber = new BehaviorSubject<IDataDiscipline[]>([]);
const BloodMagicSubscriber = new BehaviorSubject<IDataBloodmagicItem[]>([])

export {
    TalentSkillSubscriber,
    SpellsSubscriber,
    DisciplinesSubscriber,
    BloodMagicSubscriber
}
